import React from "react";
import { object } from "prop-types";
import get from "lodash/get";
import Separator from "../../atoms/separator";

import "./collection-widget-top.m.css";

const CollectionWidgetTop = ({ collection }) => {
  const content = get(collection, ["associated-metadata", "content"], "");
  return (
    <div styleName="border-wrapper">
      <Separator />
      <div styleName="wrapper" dangerouslySetInnerHTML={{ __html: content }}></div>
    </div>
  );
};

CollectionWidgetTop.propTypes = {
  collection: object
};

export default CollectionWidgetTop;
